import React from "react";
import { Link } from "react-router-dom";

const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-tight transition-all duration-300 ease-luxury whitespace-nowrap select-none focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-base disabled:opacity-50 disabled:pointer-events-none";

const sizes = {
    sm: "h-9 px-4 text-[13px]",
    md: "h-11 px-6 text-[14px]",
    lg: "h-12 px-7 text-[15px]",
};

const variants = {
    primary:
        "bg-[var(--accent)] text-[#0a0a0b] hover:brightness-110 zen-glow-on-hover",
    ghost:
        "border border-[var(--border-default)] text-text-primary hover:bg-[var(--bg-elevated)] hover:border-[rgba(124,255,79,0.4)]",
    subtle:
        "border border-[var(--border-default)] text-text-primary hover:text-[var(--accent)] hover:border-[rgba(124,255,79,0.5)] hover:bg-[rgba(124,255,79,0.04)] zen-glow-on-hover",
};

export const Button = ({
    as,
    href,
    to,
    external = false,
    variant = "primary",
    size = "md",
    className = "",
    children,
    "data-testid": testId,
    ...props
}) => {
    const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;

    if (to) {
        return (
            <Link to={to} className={cls} data-testid={testId} {...props}>
                {children}
            </Link>
        );
    }
    if (href) {
        return (
            <a
                href={href}
                target={external ? "_blank" : undefined}
                rel={external ? "noopener noreferrer" : undefined}
                className={cls}
                data-testid={testId}
                {...props}
            >
                {children}
            </a>
        );
    }
    const Tag = as || "button";
    return (
        <Tag className={cls} data-testid={testId} {...props}>
            {children}
        </Tag>
    );
};

export default Button;
